import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import adminReducer from "./admin";
import reportReducer from "./downloadreports";
export const store = configureStore({
    reducer:{
        auth:authReducer ,
        adminActionData:adminReducer,
        report:reportReducer
    }
})